import { MouseEvent, useState } from 'react';
import { Box, Theme } from '@mui/material';
import { Popover } from '@components/popover/Popover';
import { Columns } from '@assets/svgs';
import { Tooltip } from '@components/tooltip';

import { CardColumnSelector, CardColumnSelectorProps } from './cardColumnSelector/CardColumnSelector';

export const ColumnSelector = (props: CardColumnSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const openPopover = Boolean(anchorEl);
  const handleOpenPopover = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosePopover = () => {
    setAnchorEl(null);
  };
  return (
    <Popover
      iconButtonProps={{
        children: (
          <Tooltip title='Toggle Displayed Columns' arrow={false}>
            <Box>
              <Columns width='16px' height='15px' />
            </Box>
          </Tooltip>
        ),
        onClick: handleOpenPopover,
        'aria-label': 'column-picker',
      }}
      open={openPopover}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '& .MuiPaper-elevation8': {
          backgroundColor: 'background.light',
          padding: 0,
          borderRadius: '4px',
          boxShadow: (theme: Theme) => theme.shadows[4],
        },
      }}
    >
      <CardColumnSelector {...props} />
    </Popover>
  );
};
export default ColumnSelector;
